import { CalendarClock, Home, MessageCircle, User } from 'lucide-react';
import { TabsShell } from '../../components/TabsShell';
import { CustomerHome } from './CustomerHome';
import { CustomerProfile } from './CustomerProfile';
import { RequestRidePage } from './RequestRidePage';
import { TripsPage } from './TripsPage';
import { RequestDetailPage } from './RequestDetailPage';
import { RideDetailPage } from '../common/RideDetailPage';
import { NotificationsPage } from '../common/NotificationsPage';
import { LiveRidePage } from './LiveRidePage';
import { PaymentsListPage } from '../common/PaymentsListPage';
import { ChatListPage, useChatUnread } from '../chat/ChatListPage';
import { ChatPage } from '../chat/ChatPage';
import { RecurringListPage } from '../recurring/RecurringListPage';
import { RecurringCreatePage } from '../recurring/RecurringCreatePage';
import { RecurringDetailPage } from '../recurring/RecurringDetailPage';
import { MyDriverPage } from './MyDriverPage';

const CustomerRide = () => <RideDetailPage role="customer" />;
const CustomerNotifications = () => <NotificationsPage back="/app/home" />;
const CustomerPayments = () => <PaymentsListPage role="customer" />;
const CustomerChats = () => <ChatListPage base="/app" />;
const CustomerChat = () => <ChatPage base="/app" />;
const CustomerRecurring = () => <RecurringListPage base="/app" />;
const CustomerRecurringDetail = () => <RecurringDetailPage base="/app" />;

export function CustomerShell() {
  const chatUnread = useChatUnread();
  return (
    <TabsShell
      base="/app"
      home="/app/home"
      tabs={[
        { tab: 'home', href: '/app/home', label: 'Inicio', icon: Home },
        { tab: 'trips', href: '/app/trips', label: 'Mis viajes', icon: CalendarClock },
        { tab: 'chat', href: '/app/chat', label: 'Chat', icon: MessageCircle, badge: chatUnread.data?.count },
        { tab: 'profile', href: '/app/profile', label: 'Perfil', icon: User },
      ]}
      routes={[
        { path: '/app/home', component: CustomerHome },
        { path: '/app/request', component: RequestRidePage },
        { path: '/app/trips', component: TripsPage },
        { path: '/app/requests/:id', component: RequestDetailPage },
        { path: '/app/rides/:id/live', component: LiveRidePage },
        { path: '/app/rides/:id', component: CustomerRide },
        { path: '/app/notifications', component: CustomerNotifications },
        { path: '/app/payments', component: CustomerPayments },
        { path: '/app/recurring', component: CustomerRecurring },
        { path: '/app/recurring/new', component: RecurringCreatePage },
        { path: '/app/recurring/:id', component: CustomerRecurringDetail },
        { path: '/app/chat', component: CustomerChats },
        { path: '/app/chat/:id', component: CustomerChat },
        { path: '/app/profile', component: CustomerProfile },
        { path: '/app/my-driver', component: MyDriverPage },
      ]}
    />
  );
}
